<template>
  <div class="py-4 container-fluid">
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header pb-0">
            <p class="text-uppercase text-center">Descarga de Layout</p>
            
          </div>
          <hr class="horizontal dark" />
                  <div class="card-body px-2 pt-2 pb-2">
                    <p class="text-uppercase text-sm">Información</p>
                    Este es el layout del archivo para procesar. Agregue o
                    modifique su información
                    <hr class="horizontal dark" />
                    <div class="row">
                      <div class="col-md-5"></div>
                      <div class="col-md-2">
                        <button class="btn btn-success" @click="download">
                          Descargar
                        </button>
                      </div>
                      <div class="col-md-5"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import facturacion from "../api/pagos";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      model: {
        token: "",
      },
    };
  },
  methods: {
    download() {
      this.model.token = localStorage.getItem("token");
      facturacion
        .getLayout(this.model)
        .then()
        .catch((err) => {
          Swal.fire({
            title: "Error de Ingreso",
            text: err,
            icon: "error",
            confirmButtonColor: "error",
            confirmButtonText: "Continuar",
          });
        });
    },
  },
};
</script>
